// extracted by mini-css-extract-plugin
module.exports = {"popoverContainer":"popover_popoverContainer__PVqi6"};